export default __webpack_public_path__ + "static/media/140.53ea3182.jpg";